import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Button from '@repo/ui/button'
import { EmergencyIcon, EyeOpenIcon, TelephoneIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import Modal, { MODAL_CONTENT_CLASSNAME } from '@repo/ui/modal'
import Typography from '@repo/ui/typography'

import { useModalManager } from '../../../../../lib/hooks/use-modal-manager'
import useTranslate from '../../../../../lib/hooks/use-translate'
import LabelWithText from '../../../ols/label-with-text'
import AffectedStaffUrgentNumberModal from './affected-staff-urgent-number-modal'

type Props = {
  affectedStaffId: number
}
const StaffPersonalSpaceUrgentNumberSection: React.FC<Props> = ({ affectedStaffId }) => {
  const { t } = useTranslate()

  const { modalState, toggleModal, closeModel } = useModalManager<'urgent-numbers'>([
    'urgent-numbers'
  ])

  return (
    <div className="flex flex-col gap-3">
      <Typography variant="secondary-body" color={tailwindColors.grey.lighter}>
        {t('staff.personal.space.my.journeys.details.tab.home.urgent.number.text')}
      </Typography>
      <InnerBox className="bg-white-hover py-5 mobile:p-3 flex flex-row justify-between items-center mobile:flex-col mobile:items-start mobile:gap-2">
        <div className="flex gap-3 items-center">
          <div className="bg-secondary-light p-2 rounded  flex items-center justify-center">
            <TelephoneIcon color={tailwindColors.secondary.DEFAULT} height="38px" width="38px" />
          </div>
          <LabelWithText
            label={t('staff.personal.space.my.journeys.details.tab.home.urgent.number.lec')}
            data={
              <Typography variant="text" color={tailwindColors.secondaryRed.DEFAULT}>
                01 42 67 00 00
              </Typography>
            }
          />
        </div>
        <Button
          icon={EyeOpenIcon}
          className="mobile:w-full"
          variant="ghost"
          onClick={() => toggleModal('urgent-numbers')}
          label={t('staff.personal.space.my.journeys.details.tab.home.urgent.number.view.fac')}
        />
      </InnerBox>

      <Modal
        isOpen={modalState['urgent-numbers']}
        title={t('staff.personal.space.my.journeys.details.tab.home.urgent.number.modal.title')}
        icon={EmergencyIcon}
        hideActions
        size={'medium'}
        onCancel={() => closeModel('urgent-numbers')}
      >
        <AffectedStaffUrgentNumberModal
          affectedStaffId={affectedStaffId}
          className={MODAL_CONTENT_CLASSNAME}
        />
      </Modal>
    </div>
  )
}

export default StaffPersonalSpaceUrgentNumberSection
